import { render, staticRenderFns } from "./AskForDelete.vue?vue&type=template&id=654edd78&"
import script from "./AskForDelete.vue?vue&type=script&lang=ts&"
export * from "./AskForDelete.vue?vue&type=script&lang=ts&"
import style0 from "./AskForDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654edd78')) {
      api.createRecord('654edd78', component.options)
    } else {
      api.reload('654edd78', component.options)
    }
    module.hot.accept("./AskForDelete.vue?vue&type=template&id=654edd78&", function () {
      api.rerender('654edd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/AskForDelete.vue"
export default component.exports